const SAFE_EMBED_HOST_SUFFIXES = [
  'youtube.com',
  'youtu.be',
  'vimeo.com',
  'wistia.com',
  'wistia.net',
]

const DEFAULT_IFRAME_ALLOW =
  'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'

const escapeHtmlAttribute = (value) =>
  String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

const normalizeIframeSource = (raw) => {
  const value = String(raw || '').trim()
  if (!value) return ''
  const withProtocol = value.startsWith('//') ? `https:${value}` : value
  let parsed
  try {
    parsed = new URL(withProtocol)
  } catch (error) {
    return ''
  }
  if (!['http:', 'https:'].includes(parsed.protocol)) return ''
  const hostname = String(parsed.hostname || '').trim().toLowerCase()
  const isAllowed = SAFE_EMBED_HOST_SUFFIXES.some((suffix) => (
    hostname === suffix || hostname.endsWith(`.${suffix}`)
  ))
  if (!isAllowed) return ''
  return parsed.toString()
}

const extractIframeAttributes = (tag) => {
  const attrs = {}
  const matcher = /([a-zA-Z_:][a-zA-Z0-9_:-]*)\s*=\s*("([^"]*)"|'([^']*)'|([^\s>]+))/g
  let match
  while ((match = matcher.exec(tag))) {
    const key = String(match[1] || '').trim().toLowerCase()
    const value = String(match[3] || match[4] || match[5] || '').trim()
    if (!key || key.startsWith('on')) continue
    attrs[key] = value
  }
  return attrs
}

export function sanitizeVideoEmbedHtml(rawHtml) {
  const html = String(rawHtml || '').trim()
  if (!html) return ''
  const iframeMatch = html.match(/<iframe\b[^>]*>(?:\s*<\/iframe>)?/i)
  if (!iframeMatch?.[0]) return ''
  const attrs = extractIframeAttributes(iframeMatch[0])
  const src = normalizeIframeSource(attrs.src)
  if (!src) return ''

  const title = attrs.title ? ` title="${escapeHtmlAttribute(attrs.title)}"` : ' title="Embedded video"'
  const width = attrs.width ? ` width="${escapeHtmlAttribute(attrs.width)}"` : ''
  const height = attrs.height ? ` height="${escapeHtmlAttribute(attrs.height)}"` : ''
  const loading = attrs.loading ? ` loading="${escapeHtmlAttribute(attrs.loading)}"` : ' loading="lazy"'
  const referrerPolicy = attrs.referrerpolicy
    ? ` referrerpolicy="${escapeHtmlAttribute(attrs.referrerpolicy)}"`
    : ' referrerpolicy="strict-origin-when-cross-origin"'
  const allow = attrs.allow
    ? ` allow="${escapeHtmlAttribute(attrs.allow)}"`
    : ` allow="${escapeHtmlAttribute(DEFAULT_IFRAME_ALLOW)}"`
  const frameBorder = attrs.frameborder ? ` frameborder="${escapeHtmlAttribute(attrs.frameborder)}"` : ' frameborder="0"'
  const allowFullScreen = (/\ballowfullscreen\b/i.test(iframeMatch[0]) || attrs.allowfullscreen !== undefined)
    ? ' allowfullscreen'
    : ''

  return `<iframe src="${escapeHtmlAttribute(src)}"${title}${width}${height}${loading}${referrerPolicy}${allow}${frameBorder}${allowFullScreen}></iframe>`
}

